var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMoneyHandcoins(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 38,
    viewBox: "0 0 36 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 38,
    rx: 4,
    fill: "#1B251A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3769 11.7041C19.0302 10.4305 17.8654 9.49402 16.4819 9.49402C14.8251 9.49402 13.4819 10.8372 13.4819 12.494C13.4819 14.1509 14.8251 15.494 16.4819 15.494C16.8722 15.494 17.245 15.4195 17.587 15.2839M19.3769 11.7041C19.7189 11.5685 20.0917 11.494 20.4819 11.494C22.1388 11.494 23.4819 12.8372 23.4819 14.494C23.4819 16.1509 22.1388 17.494 20.4819 17.494C19.0985 17.494 17.9337 16.5576 17.587 15.2839M19.3769 11.7041C17.9737 12.2604 17.1934 13.838 17.587 15.2839M12.4819 27.494H14.4819C14.4819 27.494 16.8736 28.4174 18.4819 28.494C22.0282 28.6629 24.8453 27.0131 27.127 24.5038C27.648 23.9308 27.6392 23.0656 27.1554 22.4608C26.5317 21.6812 25.3593 21.6181 24.5772 22.2388C23.7155 22.9226 22.5717 23.6919 21.4819 23.994C19.9766 24.4113 18.4819 24.494 18.4819 24.494C26.4819 23.994 23.4819 17.4939 12.4819 21.9941M10.4819 28.494C9.37738 28.494 8.48195 27.5986 8.48195 26.494V22.494C8.48195 21.3894 9.37738 20.494 10.4819 20.494C11.5865 20.494 12.4819 21.3894 12.4819 22.494V26.494C12.4819 27.5986 11.5865 28.494 10.4819 28.494Z",
    stroke: "#E8F2EC",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneyHandcoins);
export default __webpack_public_path__ + "static/media/money-hand, coins.425c1bf8ab16533812e0c02c1d602f5f.svg";
export { ForwardRef as ReactComponent };